<template>
    <div class="componentRoot">
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-card class="pa-4" flat>
                        <TimeTableVue :readonly="false" :startDate="activeDate"
                             />
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <LoadingScreenVue :loading="loading" />
    </div>
</template>

<script>
import TimeTableVue from "../../../components/calendar/TimeTableParent.vue";

export default {
    name: "calendarRoot",

    props: [
    ],
    emits: ["refetch"],

    data() {
        return {
            loading: false,
            refreshTimeTable: 0,

            activeDate: undefined
        };
    },

    components: {
        TimeTableVue
    },

    watch: {

    },

    computed: {
    },

    methods: {
        setLoading(val) {
            this.loading = val
        }
    },

    mounted(){
        this.activeDate = localStorage.getItem("date")
    }
};
</script>
